export default __webpack_public_path__ + "94e576aa509ef694ad629e96ea455d54.svg";